import $ from 'jquery';
import _ from 'underscore';
import smoothScroll from '../../vendor/smooth-scroll';
import google from '../google/google';
import '../../vendor/jquery.outside-events';

if ($('option[data-download]').length) {
  $('.js-toolbox').append('<span class="js-lightbox" data-target="email-prompt" />');

  var lightbox = $('.js-lightbox[data-target="email-prompt"]');
  var activeClass = 'js-active';

  var downloadContainer = $('.download-container');
  var emailPrompt = $('.js-email-prompt', downloadContainer);
  var submitBtn = $('.js-submit-email', downloadContainer);
  var closeBtn = $('.js-close', downloadContainer);

  $('option[data-download]').each(function (i) {
    var option = $(this);
    var docToDownload = option.attr('data-download');

    //Selected option is a download
    if (docToDownload) {
      var select = option.parent('select');
      var isDummyContent = select.hasClass('html-demo');

      select.on('change', function (e) {
        var emailRequired = false;
        var emailAttr = option.attr('data-email-required');

        // if the option has the data-email-required attrribute set the emailRequired flag to true
        if (typeof emailAttr !== typeof undefined && emailAttr !== false) {
          emailRequired = true;
        }

        if (option.is(':selected')) {
          if (emailRequired) {
            emailPrompt.find('.error').hide();
            promptForEmail(docToDownload, option, select);
          } else {
            //call
            isDummyContent
              ? triggerDownload(docToDownload, select)
              : DownloadJS(docToDownload, option, select);
          }
        }
      });
    }
  });
}

function promptForEmail(docToDownload, option, select) {
  emailPrompt.addClass(activeClass);
  lightbox.addClass(activeClass);

  smoothScroll.smoothScrollTo(emailPrompt);
  downloadContainer.on('clickoutside', hideLightbox);
  closeBtn.on('click', hideLightbox);

  //Set hidden
  $('#DownloadRequest_AttachmentGuid').val(docToDownload);

  submitBtn.on('click', function (e) {
    if (!checkEmailValidity()) {
      emailPrompt.find('.error.invalidemail').show();
      return false;
    }
    if (!checkTermsAgreed()) {
      emailPrompt.find('.error.terms').show();
      return false;
    }

    //GA
    google.sendTo('Downloads', 'Getdocument with Email: ' + option.html(), 'Downloads');

    option.removeAttr('data-email-required');
    hideLightbox();
  });
}

function checkEmailValidity() {
  var emailVal = $('#DownloadRequest_EmailAddress').val();
  var re = /[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}/gim;

  // check the inputfield
  if (
    !re.test(emailVal) ||
    emailVal.indexOf('.') < 0 ||
    emailVal.indexOf('@') < 0 ||
    emailVal.length < 4
  ) {
    emailPrompt.find('.error.invalidemail').show();
    return false;
  } else {
    emailPrompt.find('.error.invalidemail').hide();
    return true;
  }
}

function checkTermsAgreed() {
  var checkbox = $('input.terms');
  var termsAgreed = false;
  if (checkbox && typeof checkbox.val() != 'undefined') {
    if (checkbox.is(':checked')) {
      termsAgreed = true; // checkbox checked
    } else {
      termsAgreed = false; // checkbox not checked
    }
  } else {
    termsAgreed = true; // checkbox not found
  }
  // check if terms agreed
  if (!termsAgreed) {
    emailPrompt.find('.error.terms').show();
    return false;
  } else {
    emailPrompt.find('.error.terms').hide();
    return true;
  }
}

function triggerDownload(docToDownload, select) {
  //call
  window.open(docToDownload, '_blank');

  _.delay(function (e) {
    // reset the select dropdown
    select.val('');
  }, 10);
}

// ajax call
function DownloadJS(val, option, select) {
  if (val !== '') {
    //GA
    google.sendTo('Downloads', 'Getdocument: ' + option.html(), 'Downloads');
    //call
    window.open('/getdownload/' + val, '_blank');
  }

  _.delay(function (e) {
    // reset the select dropdown
    select.val('');
  }, 6);
}

function hideLightbox() {
  emailPrompt.removeClass(activeClass);
  lightbox.removeClass(activeClass);
}

//External link to download
function DownloadLink() {
  if ($('#AttachmentGuid').val() !== '') {
    var val = $('#AttachmentGuid').val();
    //call
    window.open('/getdownload/' + val, '_blank');
  }
}

export default {
  DownloadLink: DownloadLink,
};
